<template>
  <div>
    <div id="content">
      <!-- Main Content -->
      <div
        class="main-content"
        v-if="loadedComponent"
        style="margin-top: -30px"
      >
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header">
                <div class="card-title">Editar Perfil</div>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-12">
                    <img
                      class="profile-pic-profile"
                      :src="user.photo"
                      alt="Chat Profile"
                      style="cursor: pointer"
                      onclick="document.getElementById('photo').click();"
                    />
                    <input
                      type="file"
                      id="photo"
                      accept="image/x-png,image/gif,image/jpeg"
                      style="display: none"
                    />
                  </div>
                  <div class="col-12" style="text-align: center; padding: 15px">
                    <small>Clique sobre a foto para alterá-la</small>
                  </div>
                  <div class="col-12">
                    <div class="form-group">
                      <label for="inputName">Nome</label>
                      <input
                        type="text"
                        v-model="user.name"
                        class="form-control"
                        id="inputName"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group">
                      <label for="inputEmail">E-mail</label>
                      <input
                        type="email"
                        class="form-control"
                        id="inputEmail"
                        v-model="user.email"
                        disabled
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group">
                      <label for="inputEmail">Senha</label>
                      <input
                        type="password"
                        class="form-control"
                        v-model="user.a_password"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group">
                      <label for="inputEmail">Confirmar Senha</label>
                      <input
                        type="password"
                        class="form-control"
                        v-model="user.password_confirmation"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <button @click="saveProfile" class="btn btn-main mb-0">
                      Salvar
                    </button>
                  </div>
                  <div class="col-12">
                    <router-link to="/profile" class="btn btn-back mb-0">
                      <i class="fas fa-arrow-left"></i> Voltar
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
    ></loading>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
export default {
  data() {
    return {
      user: {
        name: "",
        password: "",
        a_password: "",
        password_confirmation: "",
        email: "",
      },
      isLoading: true,
      fullPage: true,
      loadedComponent: false,
    };
  },
  computed: {},
  methods: {
    bringData: function () {
      const self = this;
      const api = self.$store.state.api + "get-profile";

      self.loadedComponent = false;
      self.isLoading = true;

      self.$http
        .get(api)
        .then((response) => {
          self.user = response.data;
          self.loadedComponent = true;
          self.isLoading = false;
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
          self.isLoading = false;
        });
    },

    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      let photo = document.getElementById("photo");

      fd.append("id", self.user.id);
      fd.append("name", self.user.name);
      fd.append("a_password", self.user.a_password ? self.user.a_password : "");
      fd.append(
        "password_confirmation",
        self.user.password_confirmation ? self.user.password_confirmation : ""
      );
      fd.append("photo", photo.files[0] ? photo.files[0] : "");

      return fd;
    },
    saveProfile: function () {
      const self = this;
      const api = self.$store.state.api + "save-profile";

      let fd = self.makeFormData();

      self.loadedComponent = false;
      self.isLoading = true;

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message("Sucesso", "Dados atualizados com sucesso!", "success");
          self.bringData();
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
  },
  components: { Loading },
  props: {},
  mounted: function () {
    this.bringData();
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Profile/Edit.vue